import type { USER_LEVEL_KEY } from './auth'

export enum MESSAGE_TEMPLATE_ID {
  /** 成片合成成功 */
  CHENGPIAN_MERGE_SUCCESS = 10000,
  /** 成片合成失败 */
  CHENGPIAN_MERGE_FAILED = 10001,
  /** 团队邀请加入 */
  TEAM_INVITE = 10002,
  /** 主体认证成功 */
  ENTITY_EMPOWER_SUCCESS = 10003,
  /** 主体认证失败 */
  ENTITY_EMPOWER_FAILED = 10004,
  /** 品牌规范跟随申请 */
  BRAND_SPECIFICATION_FOLLOW_APPLY = 10005,
  /** 转让超级管理员成功，转让给XXX */
  TRANSFER_SUPER_ADMINISTRATOR_SUCCESS = 10006,
  /** 转让超级管理员成功，XXX转让给我 */
  ACCEPT_TRANSFER_SUPER_ADMINISTRATOR_SUCCESS = 10007,
  /** 品牌规范跟随申请成功 */
  BRAND_SPECIFICATION_FOLLOW_APPLY_SUCCESS = 10008,
  /** 品牌规范跟随申请失败 */
  BRAND_SPECIFICATION_FOLLOW_APPLY_FAILED = 10009,
  /** 活动参与成功 */
  ACTIVITY_APPLY_SUCCESS = 10010,
  /** 作品渲染成功 */
  COMPOSITION_RENDER_SUCCESS = 10011,
  /** 作品渲染失败 */
  COMPOSITION_RENDER_FAILED = 10012,
  /** 作品取消渲染 */
  COMPOSITION_RENDER_CANCEL = 10013,
  /** 排队加速成功 */
  QUEUE_ACCELERATION_SUCCESS = 10014,
  /** 排队加速失败 */
  QUEUE_ACCELERATION_FAILED = 10015,
  /** 成片发布成功 */
  CHENGPIAN_PUBLISH_SUCCESS = 10016,
  /** 成片发布失败 */
  CHENGPIAN_PUBLISH_FAILED = 10017,
  /** 言币退回 */
  YANBIN_RETURN = 10018,
  /** 成片合成取消 */
  CHENGPIAN_MERGE_CANCEL = 10019,
  /** 试用权益到账 */
  TRIAL_BENEFITS_RECEIVED = 10020,

  /** 收到作品分享 */
  COMPOSITION_SHARING = 20000,
  /** 收到成片分享 */
  CHENGPIAN_SHARING = 20001,
  /** 收到成片模板分享 */
  CHENGPIAN_TEMPLATE_SHARING = 20002,
  /** 收到资源分享 */
  ASSET_SHARING = 20003,

  /** 收到视频分享 */
  VIDEO_SHARING = 20004,

  /** 运营消息 */
  MARKETING_MESSAGE = 30000,

  /** 个人套餐即将过期 */
  PERSONAL_PACKAGE_IS_ABOUT_TO_EXPIRE = 40000,
  /** 企业套餐即将过期 */
  ENTERPRISE_PACKAGE_IS_ABOUT_TO_EXPIRE = 40001,
  /** 套餐购买成功 */
  PACKAGE_PURCHASE_SUCCESS = 40002,
  /** 套餐续费成功 */
  PACKAGE_RENEWAL_SUCCESS = 40003,
  /** 套餐升级成功 */
  PACKAGE_UPGRADE_SUCCESS = 40004,
  /** 权益购买成功 */
  EQUITY_PURCHASE_SUCCESS = 40005,
  /** 言币不足 */
  YANBI_INSUFFICIENT = 40006,
  /** 子账号已满 */
  SUBACCOUNT_INSUFFICIENT = 40007,
  /** 转授权认证成功 */
  SUBLICENSE_SUCCESS = 40008,
  /** 转授权认证失败 */
  SUBLICENSE_FAILED = 40009,
  /** 言币即将过期 */
  YANBI_EXPIRING_SOOM = 40010,
  /** 个人套餐已过期 */
  PERSONAL_PACKAGE_IS_EXPIRE = 40011,
  /** 企业套餐已过期 */
  ENTERPRISE_PACKAGE_IS_EXPIRE = 40012,
  /** 兑换权益已到账 */
  EXCHANGE_EQUITY_RECEIVED = 40013,
  /** 拉新活动权益已到账 */
  INVITE_NEW_USER = 40014,
  /** 云存储空间不足 **/
  STORAGE_LESS_THAN = 40015,
  /** 云存储空间已满 **/
  STORAGE_FULL = 40016,
  /** 云存储空间将到期 **/
  STORAGE_EXPIRE = 40017,
  /** 存储空间已满要加购 **/
  STORAGE_FULL_BUY = 40018,
  /** 用户问题分配 **/
  USER_QUESTION_SEND = 10022,
  /** 认证审批通过 **/
  USER_VERIFY_SUCCESS = 10023,
  /** 认证审批驳回 **/
  USER_VERIFY_FAIL = 10024,
}

export enum RoomType {
  PERSONAL = 0,
  TEAM = 1,
}

export interface Message {
  id: number
  title: string
  view_url: string
  from_user_avatar_url?: string
  content: string
  is_read: boolean
  category: '系统消息' | '营销消息' | '权益消息'
  template_id: MESSAGE_TEMPLATE_ID
  template_name: string
  message?: string
  publish_time: number
  is_processed?: boolean
  is_interactive?: boolean
  extra_json: {
    picture_url?: string
    source_operational_msg_id?: number
    msg_id?: number
    resource_type?: number
    room_type?: RoomType
    generate_record_task_id?: number
    task_name?: string
    rights_type?: USER_LEVEL_KEY
    rights_name?: string
  }
}

export interface Messages {
  messages: Message[]
  total: number
}

export interface MessagesRequest {
  page: number
  page_size: number
  to_user_id: string
  is_read?: boolean
  template_ids?: string
}

export interface MessageCount {
  count: number
}

export interface MessageRead {
  count: number
}

export interface MessageCountRequest {
  to_user_id: string
  is_read?: boolean
}

export interface SingleMessageReadRequest {
  message_id: number
  to_user_id: string
}

export interface SingleMessageHandledRequest {
  message_id: number
  to_user_id: string
}

export interface AllMessageReadRequest {
  to_user_id: string
}

export interface ProductUpdateMsgTab {
  id: number
  title: string // 标题
  introduce_picture_path: string // 介绍动图链接路径
  introduce_picture_url: string // 介绍动图链接
  describe_content: string[] // 功能描述列表
}

export interface ProductUpdateMsg {
  id: number // 产品更新通知id
  version_number: string // 版本号
  tab_card_list: ProductUpdateMsgTab[] // Tab卡片列表
  publish_start_datetime: string // 发布开始时间
  publish_end_datetime: string // 发布结束时间
  online_status: 2 // 上线状态：0-已上线，1-已下线，2-待上线
  editor_id: number // 最近修改人user_id
  editor_name: string // 最近修改人名称
  create_time: string // 创建时间
  update_time: string // 更新时间
  document_url: string // 文档链接
}
